// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { Html5QrcodeScanner } from "html5-qrcode";

// export default function MerchantScanner() {
//   const navigate = useNavigate();
//   const scannerRef = useRef(null);

//   // Merchant State
//   const [merchantId, setMerchantId] = useState("");

//   // Scanned Live Data States
//   const [customerId, setCustomerId] = useState("");
//   const [couponCode, setCouponCode] = useState("");
//   const [scannedRewardText, setScannedRewardText] = useState("");
  
//   // UI & Processing States
//   const [isScanned, setIsScanned] = useState(false);
//   const [billAmount, setBillAmount] = useState("");
//   const [isPercentageOff, setIsPercentageOff] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [apiResponse, setApiResponse] = useState(null);

//   // Load Merchant ID from LocalStorage
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData && parsedData.merchant) {
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       alert("Merchant data missing. Redirecting to login.");
//       navigate("/login");
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Initialize Camera Scanner Component
//   useEffect(() => {
//     if (!merchantId || isScanned) return;

//     // Config for Scanner
//     const scanner = new Html5QrcodeScanner("qr-reader-box", {
//       fps: 15,
//       qrbox: { width: 280, height: 280 },
//       rememberLastUsedCamera: true,
//       supportedScanTypes: [0] // Camera scan only
//     });

//     scanner.render(onScanSuccess, onScanFailure);
//     scannerRef.current = scanner;

//     return () => {
//       if (scannerRef.current) {
//         scannerRef.current.clear().catch((err) => console.warn("Scanner clear error:", err));
//       }
//     };
//   }, [merchantId, isScanned]);

//   // Handle Successful QR Scan
//   const onScanSuccess = (decodedText) => {
//     try {
//       // Audio feedback on successful scan
//       const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-600.wav");
//       audio.play().catch(() => {});

//       setIsScanned(true);
//       if (scannerRef.current) {
//         scannerRef.current.clear();
//       }

//       // Parse the Scanned Text (Expects JSON from customer app QR)
//       // Example: {"customer_id": "CMVC497B3A688", "coupon_code": "7A093F71", "reward": "10% off"}
//       const data = JSON.parse(decodedText);
      
//       setCustomerId(data.customer_id || data.customerId || "");
//       setCouponCode(data.coupon_code || data.couponCode || "");
      
//       const rewardText = data.reward || "";
//       setScannedRewardText(rewardText);

//       // System Smart Detection for Percentage Off Rules
//       const textLower = rewardText.toLowerCase();
//       if (textLower.includes("%") || textLower.includes("off") || textLower.includes("percent")) {
//         setIsPercentageOff(true);
//       } else {
//         setIsPercentageOff(false);
//         // Direct Action Trigger if it's a simple item (e.g. Free Coffee)
//         executeRedemption(data.customer_id, data.coupon_code, "");
//       }

//     } catch (error) {
//       // Fallback: If scanned QR text is simple raw text separated by comma/space
//       console.warn("QR is not standard JSON, attempting fallback parsing:", decodedText);
//       const parts = decodedText.split(",");
//       if (parts.length >= 2) {
//         setCustomerId(parts[0].trim());
//         setCouponCode(parts[1].trim());
//         setIsPercentageOff(false);
//         executeRedemption(parts[0].trim(), parts[1].trim(), "");
//       } else {
//         alert("Invalid QR Code structure. Please scan a valid Count My Visit Coupon.");
//         setIsScanned(false);
//       }
//     }
//   };

//   const onScanFailure = (error) => {
//     // Verbose logging silent to avoid UI clutter
//   };

//   // Execute Backend Network Request
//   const executeRedemption = (custId, cpCode, finalBill) => {
//     setLoading(true);
//     const formdata = new FormData();
//     formdata.append("customer_id", custId || customerId);
//     formdata.append("merchant_id", merchantId);
//     formdata.append("coupon_code", cpCode || couponCode);
    
//     if (finalBill) {
//       formdata.append("bill_amount", finalBill);
//     }

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/redeem_reward.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         setLoading(false);
//         let cleanJsonString = result;
//         if (result.includes("DATABASE CONNECTED")) {
//           cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//         }

//         const parsedData = JSON.parse(cleanJsonString);
//         setApiResponse(parsedData);
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Redemption Sync Error:", error);
//         alert("Server validation communication failure.");
//       });
//   };

//   const handleBillSubmit = (e) => {
//     e.preventDefault();
//     if (!billAmount) {
//       alert("Please enter a valid bill amount!");
//       return;
//     }
//     executeRedemption(customerId, couponCode, billAmount);
//   };

//   const resetScannerState = () => {
//     setIsScanned(false);
//     setCustomerId("");
//     setCouponCode("");
//     setScannedRewardText("");
//     setBillAmount("");
//     setIsPercentageOff(false);
//     setApiResponse(null);
//   };

//   return (
//     <>
//       <style>{`
//         .scanner-layout { min-height: 100vh; background: #0f172a; color: #f8fafc; padding: 24px; font-family: -apple-system, BlinkMacSystemFont, sans-serif; display: flex; flex-direction: column; align-items: center; }
//         .scanner-card { width: 100%; max-width: 550px; background: #1e293b; border-radius: 24px; padding: 32px; box-shadow: 0 20px 40px rgba(0,0,0,0.3); border: 1px solid #334155; text-align: center; margin-top: 20px; }
        
//         .header-section { width: 100%; max-width: 550px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
//         .back-workspace-btn { background: #334155; color: white; border: none; padding: 10px 20px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .back-workspace-btn:hover { background: #475569; }

//         /* Customizing html5-qrcode library wrapper elements */
//         #qr-reader-box { border: none !important; background: #1e293b; border-radius: 16px; overflow: hidden; }
//         #qr-reader-box__dashboard_section_csr button { background: #ff8c42 !important; color: white !important; border: none !important; padding: 10px 20px !important; border-radius: 8px !important; font-weight: 600 !important; cursor: pointer !important; margin: 10px 0 !important; }
//         #qr-reader-box__status_span { color: #94a3b8 !important; font-size: 13px !important; }
//         video { border-radius: 16px; width: 100% !important; object-fit: cover; }

//         .bill-input-form input { width: 100%; height: 54px; border: 2px solid #475569; background: #0f172a; border-radius: 14px; padding: 0 16px; font-size: 18px; color: white; text-align: center; outline: none; margin-bottom: 20px; transition: 0.25s; }
//         .bill-input-form input:focus { border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.2); }
        
//         .action-btn { width: 100%; height: 54px; border: none; border-radius: 14px; font-size: 16px; font-weight: 700; cursor: pointer; transition: 0.2s; }
//         .btn-orange { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 15px rgba(255,94,98,0.3); }
//         .btn-green { background: #10b981; color: white; }
        
//         .result-box { padding: 24px; border-radius: 16px; margin-top: 10px; text-align: left; }
//         .success-bg { background: rgba(16, 185, 129, 0.15); border: 1px solid #10b981; color: #34d399; }
//         .failed-bg { background: rgba(239, 68, 68, 0.15); border: 1px solid #ef4444; color: #f87171; }
        
//         .data-badge { background: #334155; padding: 4px 10px; border-radius: 6px; font-family: monospace; color: #e2e8f0; font-size: 13px; }
//       `}</style>

//       <div className="scanner-layout">
        
//         <div className="header-section">
//           <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#ff8c42" }}>⚡ Live Counter Scan</h2>
//           <button className="back-workspace-btn" onClick={() => navigate(-1)}>
//             ⬅️ Dashboard
//           </button>
//         </div>

//         <div className="scanner-card">
//           {!isScanned ? (
//             <>
//               <h3 style={{ marginBottom: "6px", fontWeight: "700" }}>Hold QR Code to Camera</h3>
//               <p style={{ color: "#94a3b8", fontSize: "14px", marginBottom: "24px" }}>
//                 Align the customer validation pass inside the active radar grid box.
//               </p>
              
//               {/* HTML5 QR SCANNER TARGET MOUNT MOUNTED HERE */}
//               <div id="qr-reader-box"></div>
//             </>
//           ) : (
//             <div>
//               {/* SCAN CAPTURED OVERLAY */}
//               <div style={{ marginBottom: "20px" }}>
//                 <span style={{ fontSize: "48px" }}>📸</span>
//                 <h3 style={{ fontSize: "22px", marginTop: "10px", color: "#38bdf8" }}>QR Payload Intercepted</h3>
//               </div>

//               {/* IF API COMPLETED SUBMISSION */}
//               {apiResponse ? (
//                 <div className={`result-box ${apiResponse.success ? "success-bg" : "failed-bg"}`}>
//                   <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>
//                     {apiResponse.success ? "✔️ Reward Redeemed Successfully" : "❌ Redemption Rejected"}
//                   </h4>
//                   <p style={{ fontSize: "14px", marginBottom: "16px", color: "#cbd5e1" }}>
//                     {apiResponse.message}
//                   </p>
                  
//                   {apiResponse.coupon_details && (
//                     <div style={{ display: "flex", flexDirection: "column", gap: "8px", fontSize: "13px", borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: "12px" }}>
//                       <div>👤 Customer ID: <span className="data-badge">{apiResponse.coupon_details.customer_id}</span></div>
//                       <div>🎫 Coupon Code: <span className="data-badge">{apiResponse.coupon_details.coupon_code}</span></div>
//                       <div>🎁 Reward item: <strong style={{ color: "#fff" }}>{apiResponse.coupon_details.reward}</strong></div>
//                       <div>📊 Status Rule: <span className="data-badge" style={{ background: "#ef4444" }}>{apiResponse.coupon_details.status.toUpperCase()}</span></div>
//                     </div>
//                   )}

//                   <button className="action-btn btn-orange" style={{ marginTop: "24px" }} onClick={resetScannerState}>
//                     🔄 Scan Next Customer
//                   </button>
//                 </div>
//               ) : (
//                 /* CONDITIONAL UI: DEMANDS MANUAL BILL AMOUNT FOR PERCENTAGE DEPLOYMENTS */
//                 <div style={{ textAlign: "left" }}>
//                   <div style={{ background: "#334155", padding: "16px", borderRadius: "12px", marginBottom: "20px" }}>
//                     <div style={{ marginBottom: "6px" }}>👤 ID: <span className="data-badge">{customerId}</span></div>
//                     <div>🎫 Code: <span className="data-badge">{couponCode}</span></div>
//                   </div>

//                   {isPercentageOff ? (
//                     <form onSubmit={handleBillSubmit} className="bill-input-form">
//                       <div style={{ background: "rgba(59, 130, 246, 0.1)", borderLeft: "4px solid #3b82f6", padding: "12px", borderRadius: "6px", fontSize: "13px", color: "#60a5fa", marginBottom: "16px" }}>
//                         % Rule Detected ({scannedRewardText}). Please submit final transaction amount to process calculation logic.
//                       </div>
//                       <label style={{ display: "block", fontSize: "13px", fontWeight: "700", marginBottom: "8px", color: "#94a3b8" }}>ENTER TOTAL BILL AMOUNT (₹)</label>
//                       <input 
//                         type="number" 
//                         placeholder="e.g. 1500" 
//                         value={billAmount} 
//                         onChange={(e) => setBillAmount(e.target.value)}
//                         required 
//                         autoFocus
//                       />
//                       <button type="submit" className="action-btn btn-orange" disabled={loading}>
//                         {loading ? "Redeeming Balance..." : "Confirm & Apply Off ✔️"}
//                       </button>
//                     </form>
//                   ) : (
//                     <div style={{ textAlign: "center", padding: "20px 0" }}>
//                       <p style={{ color: "#94a3b8", marginBottom: "16px" }}>Processing Direct Flat Strategy Campaign...</p>
//                       <div className="spinner" style={{ border: "4px solid rgba(255,255,255,0.1)", borderLeftColor: "#ff8c42", borderRadius: "50%", width: "36px", height: "36px", margin: "0 auto", animation: "spin 1s linear infinite" }}></div>
//                       <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//                     </div>
//                   )}

//                   <button className="back-workspace-btn" style={{ width: "100%", marginTop: "12px", height: "50px" }} onClick={resetScannerState}>
//                     ❌ Cancel / Reset
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//       </div>
//     </>
//   );
// }

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import { Html5QrcodeScanner } from "html5-qrcode";

// export default function MerchantScanner() {
//   const navigate = useNavigate();
//   const scannerRef = useRef(null);

//   // Merchant State
//   const [merchantId, setMerchantId] = useState("");

//   // Scanned Live Data States
//   const [customerId, setCustomerId] = useState("");
//   const [couponCode, setCouponCode] = useState("");
//   const [scannedRewardText, setScannedRewardText] = useState("");
  
//   // UI & Processing States
//   const [isScanned, setIsScanned] = useState(false);
//   const [billAmount, setBillAmount] = useState("");
//   const [isPercentageOff, setIsPercentageOff] = useState(false);
//   const [discountPercentValue, setDiscountPercentValue] = useState(0); 
//   const [loading, setLoading] = useState(false);
//   const [apiResponse, setApiResponse] = useState(null);

//   // Load Merchant ID from LocalStorage
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData && parsedData.merchant) {
//           setMerchantId(parsedData.merchant.user_id);
//           return;
//         }
//       }
//       alert("Merchant data missing. Redirecting to login.");
//       navigate("/login");
//     } catch (error) {
//       console.error("Error reading localStorage:", error);
//     }
//   }, [navigate]);

//   // Initialize Camera Scanner Component
//   useEffect(() => {
//     if (!merchantId || isScanned) return;

//     const scanner = new Html5QrcodeScanner("qr-reader-box", {
//       fps: 15,
//       qrbox: { width: 280, height: 280 },
//       rememberLastUsedCamera: true,
//       supportedScanTypes: [0] // Camera scan only
//     });

//     scanner.render(onScanSuccess, onScanFailure);
//     scannerRef.current = scanner;

//     return () => {
//       if (scannerRef.current) {
//         scannerRef.current.clear().catch((err) => console.warn("Scanner clear error:", err));
//       }
//     };
//   }, [merchantId, isScanned]);

//   // Handle Successful QR Scan
//   const onScanSuccess = (decodedText) => {
//     try {
//       const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-600.wav");
//       audio.play().catch(() => {});

//       setIsScanned(true);
//       if (scannerRef.current) {
//         scannerRef.current.clear();
//       }

//       // Parse Scanned Text JSON
//       const data = JSON.parse(decodedText);
//       const custId = data.customer_id || data.customerId || "";
//       const cpCode = data.coupon_code || data.couponCode || "";
//       const rewardText = data.reward || "";

//       setCustomerId(custId);
//       setCouponCode(cpCode);
//       setScannedRewardText(rewardText);

//       // --- Smart Check for Percentage Coupon on Scan ---
//       const textLower = rewardText.toLowerCase();
//       if (textLower.includes("%") || textLower.includes("percent") || textLower.includes("off on bill")) {
//         setIsPercentageOff(true);
//         // Extract number from string (e.g., "50% off on bill" -> 50)
//         const match = textLower.match(/(\d+)/);
//         const pct = match ? parseInt(match[0]) : 0;
//         setDiscountPercentValue(pct);
//       } else {
//         // Simple voucher item h, toh direct verify & hit endpoint
//         setIsPercentageOff(false);
//         executeRedemption(custId, cpCode, "");
//       }

//     } catch (error) {
//       console.warn("QR is not standard JSON, attempting fallback parsing:", decodedText);
//       const parts = decodedText.split(",");
//       if (parts.length >= 2) {
//         const custId = parts[0].trim();
//         const cpCode = parts[1].trim();
//         setCustomerId(custId);
//         setCouponCode(cpCode);
//         setIsPercentageOff(false);
//         executeRedemption(custId, cpCode, "");
//       } else {
//         alert("Invalid QR Code structure. Please scan a valid Coupon.");
//         setIsScanned(false);
//       }
//     }
//   };

//   const onScanFailure = (error) => {
//     // Silent
//   };

//   // Final API Sync Submission
//   const executeRedemption = (custId, cpCode, finalBill) => {
//     setLoading(true);
//     const formdata = new FormData();
//     formdata.append("customer_id", custId || customerId);
//     formdata.append("merchant_id", merchantId);
//     formdata.append("coupon_code", cpCode || couponCode);
    
//     if (finalBill) {
//       formdata.append("bill_amount", finalBill);
//     }

//     const requestOptions = {
//       method: "POST",
//       body: formdata,
//       redirect: "follow"
//     };

//     fetch("https://countmyvisit.com/Apis/redeem_reward.php", requestOptions)
//       .then((response) => response.text())
//       .then((result) => {
//         setLoading(false);
//         let cleanJsonString = result;
//         if (result.includes("DATABASE CONNECTED")) {
//           cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
//         }

//         const parsedData = JSON.parse(cleanJsonString);
//         setApiResponse(parsedData);
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Redemption Sync Error:", error);
//         alert("Server validation communication failure.");
//       });
//   };

//   const handlePercentageFormSubmit = (e) => {
//     e.preventDefault();
//     if (!billAmount || parseFloat(billAmount) <= 0) {
//       alert("Please enter a valid bill amount!");
//       return;
//     }
//     executeRedemption(customerId, couponCode, billAmount);
//   };

//   // Live Math Calculations
//   const calculatedDiscount = (parseFloat(billAmount) * discountPercentValue) / 100 || 0;
//   const finalPayableAmount = parseFloat(billAmount) - calculatedDiscount || 0;

//   const resetScannerState = () => {
//     setIsScanned(false);
//     setCustomerId("");
//     setCouponCode("");
//     setScannedRewardText("");
//     setBillAmount("");
//     setIsPercentageOff(false);
//     setDiscountPercentValue(0);
//     setApiResponse(null);
//   };

//   return (
//     <>
//       <style>{`
//         .scanner-layout { min-height: 100vh; background: #0f172a; color: #f8fafc; padding: 24px; font-family: -apple-system, BlinkMacSystemFont, sans-serif; display: flex; flex-direction: column; align-items: center; }
//         .scanner-card { width: 100%; max-width: 550px; background: #1e293b; border-radius: 24px; padding: 32px; box-shadow: 0 20px 40px rgba(0,0,0,0.3); border: 1px solid #334155; text-align: center; margin-top: 20px; }
        
//         .header-section { width: 100%; max-width: 550px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; }
//         .back-workspace-btn { background: #334155; color: white; border: none; padding: 10px 20px; border-radius: 12px; font-weight: 600; cursor: pointer; transition: 0.2s; }
//         .back-workspace-btn:hover { background: #475569; }

//         #qr-reader-box { border: none !important; background: #1e293b; border-radius: 16px; overflow: hidden; }
//         #qr-reader-box__dashboard_section_csr button { background: #ff8c42 !important; color: white !important; border: none !important; padding: 10px 20px !important; border-radius: 8px !important; font-weight: 600 !important; cursor: pointer !important; margin: 10px 0 !important; }
//         #qr-reader-box__status_span { color: #94a3b8 !important; font-size: 13px !important; }
//         video { border-radius: 16px; width: 100% !important; object-fit: cover; }

//         .bill-input-form input { width: 100%; height: 54px; border: 2px solid #475569; background: #0f172a; border-radius: 14px; padding: 0 16px; font-size: 20px; color: white; text-align: center; outline: none; margin-bottom: 20px; transition: 0.25s; font-weight: bold; }
//         .bill-input-form input:focus { border-color: #ff8c42; box-shadow: 0 0 0 4px rgba(255,140,66,0.2); }
        
//         .action-btn { width: 100%; height: 54px; border: none; border-radius: 14px; font-size: 16px; font-weight: 700; cursor: pointer; transition: 0.2s; }
//         .btn-orange { background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white; box-shadow: 0 4px 15px rgba(255,94,98,0.3); }
//         .btn-green { background: #10b981; color: white; }
        
//         .result-box { padding: 24px; border-radius: 16px; margin-top: 10px; text-align: left; }
//         .success-bg { background: rgba(16, 185, 129, 0.15); border: 1px solid #10b981; color: #34d399; }
//         .failed-bg { background: rgba(239, 68, 68, 0.15); border: 1px solid #ef4444; color: #f87171; }
        
//         .data-badge { background: #334155; padding: 4px 10px; border-radius: 6px; font-family: monospace; color: #e2e8f0; font-size: 13px; }
//         .calc-box { background: #0f172a; padding: 18px; border-radius: 14px; margin-bottom: 20px; border: 2px dashed #475569; }
//       `}</style>

//       <div className="scanner-layout">
        
//         <div className="header-section">
//           <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#ff8c42" }}>⚡ Live Counter Scan</h2>
//           <button className="back-workspace-btn" onClick={() => navigate(-1)}>
//             ⬅️ Dashboard
//           </button>
//         </div>

//         <div className="scanner-card">
//           {!isScanned ? (
//             <>
//               <h3 style={{ marginBottom: "6px", fontWeight: "700" }}>Hold QR Code to Camera</h3>
//               <p style={{ color: "#94a3b8", fontSize: "14px", marginBottom: "24px" }}>
//                 Align the customer validation pass inside the active radar grid box.
//               </p>
//               <div id="qr-reader-box"></div>
//             </>
//           ) : (
//             <div>
//               <div style={{ marginBottom: "20px" }}>
//                 <span style={{ fontSize: "48px" }}>📸</span>
//                 <h3 style={{ fontSize: "22px", marginTop: "10px", color: "#38bdf8" }}>QR Code Scanned</h3>
//               </div>

//               {/* LOADING STATE */}
//               {loading && (
//                 <div style={{ textAlign: "center", padding: "20px 0" }}>
//                   <p style={{ color: "#94a3b8", marginBottom: "16px" }}>Processing Sync...</p>
//                   <div className="spinner" style={{ border: "4px solid rgba(255,255,255,0.1)", borderLeftColor: "#ff8c42", borderRadius: "50%", width: "36px", height: "36px", margin: "0 auto", animation: "spin 1s linear infinite" }}></div>
//                 </div>
//               )}

//               {/* FLOW A: IF PERCENTAGE REWARD DETECTED & NOT SYNCED YET */}
//               {!loading && isPercentageOff && !apiResponse && (
//                 <div style={{ textAlign: "left" }}>
//                   <div style={{ background: "rgba(251, 146, 60, 0.15)", borderLeft: "4px solid #ff8c42", padding: "14px", borderRadius: "8px", fontSize: "15px", color: "#fb923c", marginBottom: "20px" }}>
//                     🔥 <strong>{discountPercentValue}% Bill Discount</strong> Coupon Detected!
//                     <div style={{ fontSize: "12px", color: "#cbd5e1", marginTop: "4px" }}>Reward: "{scannedRewardText}"</div>
//                   </div>

//                   <form onSubmit={handlePercentageFormSubmit} className="bill-input-form">
//                     <label style={{ display: "block", fontSize: "13px", fontWeight: "700", marginBottom: "8px", color: "#94a3b8" }}>
//                       PLEASE ENTER TOTAL BILL AMOUNT (₹)
//                     </label>
//                     <input 
//                       type="number" 
//                       placeholder="e.g. 1200" 
//                       value={billAmount} 
//                       onChange={(e) => setBillAmount(e.target.value)}
//                       required
//                       autoFocus
//                     />

//                     {billAmount && parseFloat(billAmount) > 0 && (
//                       <div className="calc-box">
//                         <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", color: "#94a3b8" }}>
//                           <span>Total Bill Amount:</span> <span>₹{billAmount}</span>
//                         </div>
//                         <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px", color: "#f87171", fontWeight: "600" }}>
//                           <span>Coupon Discount ({discountPercentValue}%):</span> <span>- ₹{calculatedDiscount.toFixed(2)}</span>
//                         </div>
//                         <hr style={{ borderColor: "#334155", margin: "12px 0", borderStyle: "solid" }} />
//                         <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "800", fontSize: "20px", color: "#34d399" }}>
//                           <span>💸 Customer Pays:</span> <span>₹{finalPayableAmount.toFixed(2)}</span>
//                         </div>
//                       </div>
//                     )}

//                     <button type="submit" className="action-btn btn-orange">
//                       ✔️ Confirm Payment & Redeem
//                     </button>
//                   </form>
//                 </div>
//               )}

//               {/* FLOW B: AFTER SERVER API SUBMISSION RESPONSE (Both Percentage and Vouchers) */}
//               {!loading && apiResponse && (
//                 <div className={`result-box ${apiResponse.success ? "success-bg" : "failed-bg"}`}>
//                   <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "12px" }}>
//                     {apiResponse.success ? "✔️ Transaction Complete" : "❌ Process Terminated"}
//                   </h4>
//                   <p style={{ fontSize: "14px", marginBottom: "16px", color: "#cbd5e1" }}>
//                     {apiResponse.message || "The action was handled successfully by backend logs."}
//                   </p>

//                   {isPercentageOff && apiResponse.success && billAmount && (
//                     <div style={{ background: "rgba(255,255,255,0.05)", padding: "12px", borderRadius: "8px", fontSize: "13px", color: "#e2e8f0" }}>
//                       <div>✅ Final Settled Amount: <strong>₹{finalPayableAmount.toFixed(2)}</strong></div>
//                       <div>📉 Saved Value: ₹{calculatedDiscount.toFixed(2)}</div>
//                     </div>
//                   )}

//                   {!isPercentageOff && apiResponse.success && (
//                     <div style={{ background: "rgba(16, 185, 129, 0.2)", padding: "12px", borderRadius: "8px", fontSize: "14px", color: "#fff", fontWeight: "600" }}>
//                       🎁 Product Voucher Applied! Deliver order successfully.
//                     </div>
//                   )}

//                   <button className="action-btn btn-orange" style={{ marginTop: "24px" }} onClick={resetScannerState}>
//                     🔄 Scan Next Customer
//                   </button>
//                 </div>
//               )}

//               {/* CANCEL BUTTON */}
//               {!loading && (
//                 <button className="back-workspace-btn" style={{ width: "100%", marginTop: "12px", height: "50px", background: "#475569" }} onClick={resetScannerState}>
//                   ❌ Cancel / Reset Scanner
//                 </button>
//               )}
//             </div>
//           )}
//         </div>

//       </div>
//     </>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Html5QrcodeScanner } from "html5-qrcode";

export default function MerchantScanner() {
  const navigate = useNavigate();
  const scannerRef = useRef(null);

  // Merchant State
  const [merchantId, setMerchantId] = useState("");

  // Scanned Live Data States
  const [customerId, setCustomerId] = useState("");
  const [couponCode, setCouponCode] = useState("");
  
  // UI & Processing States
  const [isScanned, setIsScanned] = useState(false);
  const [billAmount, setBillAmount] = useState("");
  const [isPercentageOff, setIsPercentageOff] = useState(false);
  const [discountPercentValue, setDiscountPercentValue] = useState(0); 
  const [loading, setLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [rewardTitleText, setRewardTitleText] = useState("");

  // Load Merchant ID from LocalStorage
  useEffect(() => {
    try {
      const savedDataString = localStorage.getItem("marchentdata");
      if (savedDataString) {
        const parsedData = JSON.parse(savedDataString);
        if (parsedData && parsedData.merchant) {
          setMerchantId(parsedData.merchant.user_id);
          return;
        }
      }
      alert("Merchant data missing. Redirecting to login.");
      navigate("/login");
    } catch (error) {
      console.error("Error reading localStorage:", error);
    }
  }, [navigate]);

  // Initialize Camera Scanner Component
  useEffect(() => {
    if (!merchantId || isScanned) return;

    const scanner = new Html5QrcodeScanner("qr-reader-box", {
      fps: 15,
      qrbox: { width: 280, height: 280 },
      rememberLastUsedCamera: true,
      supportedScanTypes: [0] // Camera scan only
    });

    scanner.render(onScanSuccess, onScanFailure);
    scannerRef.current = scanner;

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch((err) => console.warn("Scanner clear error:", err));
      }
    };
  }, [merchantId, isScanned]);

  // Handle Successful QR Scan
  const onScanSuccess = (decodedText) => {
    try {
      const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-600.wav");
      audio.play().catch(() => {});

      setIsScanned(true);
      if (scannerRef.current) {
        scannerRef.current.clear();
      }

      // Parse Scanned Text JSON
      const data = JSON.parse(decodedText);
      const custId = data.customer_id || data.customerId || "";
      const cpCode = data.coupon_code || data.couponCode || "";

      setCustomerId(custId);
      setCouponCode(cpCode);

      // Pehle direct API hit karke check karenge coupon status kya hai
      executeRedemption(custId, cpCode, "");

    } catch (error) {
      console.warn("QR is not standard JSON, attempting fallback parsing:", decodedText);
      const parts = decodedText.split(",");
      if (parts.length >= 2) {
        const custId = parts[0].trim();
        const cpCode = parts[1].trim();
        setCustomerId(custId);
        setCouponCode(cpCode);
        executeRedemption(custId, cpCode, "");
      } else {
        alert("Invalid QR Code structure. Please scan a valid Coupon.");
        setIsScanned(false); 
        
      }
    }
  };

  const onScanFailure = (error) => {
    // Silent
  };

  // API Sync Submission
  const executeRedemption = (custId, cpCode, finalBill) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("customer_id", custId || customerId);
    formdata.append("merchant_id", merchantId);
    formdata.append("coupon_code", cpCode || couponCode);
    
    if (finalBill) {
      formdata.append("bill_amount", finalBill);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    fetch("https://countmyvisit.com/Apis/redeem_reward.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        setLoading(false);
        let cleanJsonString = result;
        if (result.includes("DATABASE CONNECTED")) {
          cleanJsonString = result.replace(/DATABASE CONNECTED/g, "").trim();
        }

        const parsedData = JSON.parse(cleanJsonString);
        setApiResponse(parsedData);

        // --- CHECKING RESPONSE STRUCT FROM API ---
        if (parsedData.success && parsedData.coupon_details) {
          const details = parsedData.coupon_details;
          setRewardTitleText(details.reward_name || "Reward Applied");

          // Agar discount_type percentage hai toh screen badal ke bill amount mangegi
          if (details.discount_type === "percentage" && parseInt(details.discount_value) > 0) {
            setIsPercentageOff(true);
            setDiscountPercentValue(parseInt(details.discount_value));
          } else {
            // Agar voucher hai ya flat item h to directly handle ho jayega
            setIsPercentageOff(false);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Redemption Sync Error:", error);
        alert("Server validation communication failure.");
      });
  };

  // Jab merchant bill enter karke finalize submission click karega (sirf percentage discount ke liye)
  const handlePercentageBillSubmit = (e) => {
    e.preventDefault();
    if (!billAmount || parseFloat(billAmount) <= 0) {
      alert("Please enter a valid bill amount!");
      return;
    }
    // Api ko dubara inform karne ya state override handle karne ke liye (Agar backend dubara expect kare to, otherwise localized screen complete block)
    alert(`Bill Processed Successfully! Final Payable Amount: ₹${finalPayableAmount.toFixed(2)}`);
    resetScannerState();
  };

  // Live Math Calculations based on Response variables
  const calculatedDiscount = (parseFloat(billAmount) * discountPercentValue) / 100 || 0;
  const finalPayableAmount = parseFloat(billAmount) - calculatedDiscount || 0;

  const resetScannerState = () => {
    setIsScanned(false);
    setCustomerId("");
    setCouponCode("");
    setBillAmount("");
    setIsPercentageOff(false);
    setDiscountPercentValue(0);
    setApiResponse(null);
    setRewardTitleText("");
  };

  return (
    <>
   <style>{`
  /* Global Reset & Box Sizing */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    -webkit-user-select: none;  /* Safari */
    -moz-user-select: none;     /* Firefox */
    -ms-user-select: none;      /* IE10+ */
    user-select: none;          /* Standard */
    -webkit-user-drag: none;    /* Prevent dragging */
  }

  /* Main Responsive Full Screen Container */
  .scanner-layout { 
    min-height: 100vh; 
    min-height: 100dvh; /* Mobile browser friendly dynamic height */
    background: #0f172a; 
    color: #f8fafc; 
    padding: 16px; 
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; 
    display: flex; 
    flex-direction: column; 
    align-items: center;
    justify-content: flex-start; /* Mobile devices par top-aligned start karega standard layout ke liye */
    width: 100%;
    overflow-x: hidden;
  }

  /* Header Section */
  .header-section { 
    width: 100%; 
    max-width: 550px; 
    display: flex; 
    justify-content: space-between; 
    align-items: center; 
    margin-bottom: 12px; 
  }

  .back-workspace-btn { 
    background: #334155; 
    color: white; 
    border: none; 
    padding: 8px 16px; 
    border-radius: 12px; 
    font-weight: 600; 
    font-size: 14px;
    cursor: pointer; 
    transition: background 0.2s ease; 
  }
  .back-workspace-btn:hover { 
    background: #475569; 
  }

  /* Responsive Card Layout */
  .scanner-card { 
    width: 100%; 
    max-width: 550px; 
    background: #1e293b; 
    border-radius: 24px; 
    padding: 24px; 
    box-shadow: 0 20px 40px rgba(0,0,0,0.3); 
    border: 1px solid #334155; 
    text-align: center; 
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  /* QR Scanner Box Sizing & Fluid Video */
  #qr-reader-box { 
    border: none !important; 
    background: #1e293b; 
    border-radius: 16px; 
    overflow: hidden; 
    width: 100%;
  }

  #qr-reader-box__dashboard_section_csr button { 
    background: #ff8c42 !important; 
    color: white !important; 
    border: none !important; 
    padding: 10px 20px !important; 
    border-radius: 8px !important; 
    font-weight: 600 !important; 
    cursor: pointer !important; 
    margin: 10px 0 !important; 
    font-size: 14px;
  }

  #qr-reader-box__status_span { 
    color: #94a3b8 !important; 
    font-size: 13px !important; 
  }

  video { 
    border-radius: 16px; 
    width: 100% !important; 
    max-height: 300px; /* Limits height on mobile vertical views */
    object-fit: cover; 
  }

  /* Bill Input Form Styling */
  .bill-input-form {
    width: 100%;
  }

  .bill-input-form input { 
    width: 100%; 
    height: 50px; 
    border: 2px solid #475569; 
    background: #0f172a; 
    border-radius: 14px; 
    padding: 0 16px; 
    font-size: 18px; 
    color: white; 
    text-align: center; 
    outline: none; 
    margin-bottom: 16px; 
    transition: all 0.25s ease; 
    font-weight: bold; 
  }
  .bill-input-form input:focus { 
    border-color: #ff8c42; 
    box-shadow: 0 0 0 4px rgba(255,140,66,0.2); 
  }
  
  /* Action Buttons */
  .action-btn { 
    width: 100%; 
    height: 50px; 
    border: none; 
    border-radius: 14px; 
    font-size: 15px; 
    font-weight: 700; 
    cursor: pointer; 
    transition: transform 0.1s ease, opacity 0.2s ease; 
  }
  .action-btn:active {
    transform: scale(0.98);
  }
  .btn-orange { 
    background: linear-gradient(135deg, #ff8c42, #ff5e62); 
    color: white; 
    box-shadow: 0 4px 15px rgba(255,94,98,0.3); 
  }
  .btn-green { 
    background: #10b981; 
    color: white; 
  }
  
  /* Calculation & Result Box */
  .calc-box { 
    background: #0f172a; 
    padding: 16px; 
    border-radius: 14px; 
    margin-bottom: 16px; 
    border: 2px dashed #475569; 
    font-size: 14px;
  }

  .result-box { 
    padding: 18px; 
    border-radius: 16px; 
    margin-top: 10px; 
    text-align: left; 
    font-size: 14px;
    line-height: 1.5;
  }
  .success-bg { 
    background: rgba(16, 185, 129, 0.15); 
    border: 1px solid #10b981; 
    color: #34d399; 
  }
  .failed-bg { 
    background: rgba(239, 68, 68, 0.15); 
    border: 1px solid #ef4444; 
    color: #f87171; 
  }

  /* --- MEDIA QUERIES FOR DETAILED RESPONSIVENESS --- */

  /* Modern Mobile Devices (Smartphones, Portrait - Up to 480px width) */
  @media (max-width: 480px) {
    .scanner-layout {
      padding: 12px 10px; /* Thoda aur edge space adjust kiya */
      justify-content: flex-start;
    }
    .header-section {
      margin-bottom: 8px;
    }
    .back-workspace-btn {
      padding: 6px 12px;
      font-size: 12px;
      border-radius: 10px;
    }
    .scanner-card {
      padding: 16px; /* Padding kam karke input aur video ke liye space banaya */
      border-radius: 18px;
      gap: 12px;
    }
    video {
      max-height: 220px; /* Mobile screens par video fitting achhi hogi */
    }
    .bill-input-form input {
      font-size: 16px;
      height: 44px;
      margin-bottom: 12px;
    }
    .action-btn {
      height: 44px;
      font-size: 14px;
      border-radius: 10px;
    }
    .calc-box, .result-box {
      padding: 12px;
      font-size: 13px;
    }
  }

  /* Large Screens (Desktop / Laptops - min-width: 768px) */
  @media (min-width: 768px) {
    .scanner-layout {
      padding: 24px;
      justify-content: center; /* Center aligning on bigger screens */
    }
    .scanner-card {
      padding: 32px;
    }
    .bill-input-form input {
      font-size: 20px;
      height: 54px;
    }
    .action-btn {
      height: 54px;
      font-size: 16px;
    }
  }
`}</style>

      <div className="scanner-layout">
        
        <div className="header-section">
          <h2 style={{ fontSize: "22px", fontWeight: "800", color: "#ff8c42" }}>⚡ Live Counter Scan</h2>
          <button className="back-workspace-btn" onClick={() => navigate(-1)}>
            ⬅️ Dashboard
          </button>
        </div>

        <div className="scanner-card">
          {!isScanned ? (
            <>
              <h3 style={{ marginBottom: "6px", fontWeight: "700" }}>Hold QR Code to Camera</h3>
              <p style={{ color: "#94a3b8", fontSize: "14px", marginBottom: "24px" }}>
                Align the customer validation pass inside the active radar grid box.
              </p>
              <div id="qr-reader-box"></div>
            </>
          ) : (
            <div>
              <div style={{ marginBottom: "20px" }}>
                <span style={{ fontSize: "48px" }}>📸</span>
                <h3 style={{ fontSize: "22px", marginTop: "10px", color: "#38bdf8" }}>QR Code Processed</h3>
              </div>

              {/* LOADING INDICATOR */}
              {loading && (
                <div style={{ textAlign: "center", padding: "20px 0" }}>
                  <p style={{ color: "#94a3b8", marginBottom: "16px" }}>Verifying with Server...</p>
                  <div className="spinner" style={{ border: "4px solid rgba(255,255,255,0.1)", borderLeftColor: "#ff8c42", borderRadius: "50%", width: "36px", height: "36px", margin: "0 auto", animation: "spin 1s linear infinite" }}></div>
                </div>
              )}

              {/* RESPONSE VIEW HANDLING */}
              {!loading && apiResponse && (
                <div className={`result-box ${apiResponse.success ? "success-bg" : "failed-bg"}`}>
                  
                  {apiResponse.success ? (
                    <>
                      <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "4px", color: "#10b981" }}>
                        ✔️ {apiResponse.message || "Redeemed Successfully"}
                      </h4>
                      <p style={{ fontSize: "14px", color: "#94a3b8", marginBottom: "16px" }}>
                        Reward: <strong>{rewardTitleText}</strong>
                      </p>

                      {/* CONDITION 1: PERCENTAGE VALUE DETECTED */}
                      {isPercentageOff ? (
                        <form onSubmit={handlePercentageBillSubmit} className="bill-input-form" style={{ marginTop: "15px" }}>
                          <div style={{ background: "rgba(251, 146, 60, 0.12)", borderLeft: "4px solid #ff8c42", padding: "12px", borderRadius: "6px", fontSize: "14px", color: "#fb923c", marginBottom: "16px" }}>
                            🏷️ <strong>{discountPercentValue}% OFF</strong> applied from server values. Please calculate the bill below.
                          </div>
                          
                          <label style={{ display: "block", fontSize: "13px", fontWeight: "700", marginBottom: "8px", color: "#e2e8f0" }}>
                            ENTER TOTAL BILL AMOUNT (₹)
                          </label>
                          <input 
                            type="number" 
                            placeholder="Enter billing value here..." 
                            value={billAmount} 
                            onChange={(e) => setBillAmount(e.target.value)}
                            required
                            autoFocus
                          />

                          {billAmount && parseFloat(billAmount) > 0 && (
                            <div className="calc-box">
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", color: "#94a3b8" }}>
                                <span>Original Bill:</span> <span>₹{billAmount}</span>
                              </div>
                              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", color: "#f87171" }}>
                                <span>Discount Approved ({discountPercentValue}%):</span> <span>- ₹{calculatedDiscount.toFixed(2)}</span>
                              </div>
                              <hr style={{ borderColor: "#334155", margin: "10px 0" }} />
                              <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold", fontSize: "18px", color: "#34d399" }}>
                                <span>👉 Net Payable:</span> <span>₹{finalPayableAmount.toFixed(2)}</span>
                              </div>
                            </div>
                          )}

                          <button type="submit" className="action-btn btn-green">
                            Done & Clear
                          </button>
                        </form>
                      ) : (
                        /* CONDITION 2: STANDARD ITEM VOUCHER */
                        <div style={{ marginTop: "10px", background: "rgba(52, 211, 153, 0.1)", padding: "16px", borderRadius: "8px", color: "#fff" }}>
                          🎁 <strong>Voucher Successfully Applied!</strong> No bill calculation needed. Please hand over the reward item to the customer.
                        </div>
                      )}
                    </>
                  ) : (
                    /* REJECTED RESPONSE BY BACKEND */
                    <>
                      <h4 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "4px" }}>
                        ❌ Redemption Rejected
                      </h4>
                      <p style={{ fontSize: "14px", color: "#f87171" }}>
                        {apiResponse.message || "This coupon code is already used or expired."}
                      </p>
                    </>
                  )}

                  <button className="action-btn btn-orange" style={{ marginTop: "24px" }} onClick={resetScannerState}>
                    🔄 Scan Next Customer
                  </button>
                </div>
              )}

              {/* ACTION RESET/CANCEL BUTTON */}
              {!loading && (
                <button className="back-workspace-btn" style={{ width: "100%", marginTop: "12px", height: "50px", background: "#475569" }} onClick={resetScannerState}>
                  ❌ Cancel & Reset Scanner
                </button>
              )}
            </div>
          )}
        </div>

      </div>
    </>
  );
}